module.exports = __webpack_public_path__ + "img/赛区球.8330e59e.png";